import { createListenerMiddleware } from "@reduxjs/toolkit";
import { createRequest } from "../../utility";
import { fetchConfig, fetchConfigSuccess, fetchConfigFailed, preparaConfig } from "./index";
import { notificationCodes, setNotification } from "../notification";
import { SAGAS_CONFIG_ERROR_TITLE, SAGAS_CONFIG_ERROR_DESCRIPTION } from "../language";
import { CONFIG_API } from "../../apiUrl";

const fetchConfigWorker = (listenerApi) => {
  createRequest(CONFIG_API.method, CONFIG_API.baseUrl, CONFIG_API.apiUrl)
    .then((response) => {
      if (response.status === 200) listenerApi.dispatch(fetchConfigSuccess(preparaConfig(response.data)));
      else throw response.message;
    })
    .catch((e) => {
      listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_CONFIG_ERROR_TITLE, description: SAGAS_CONFIG_ERROR_DESCRIPTION })); //prettier-ignore
      listenerApi.dispatch(fetchConfigFailed());
    });
};

export const configurationMiddleware = createListenerMiddleware();

configurationMiddleware.startListening({
  actionCreator: fetchConfig,
  effect: async (action, listenerApi) => fetchConfigWorker(listenerApi),
});
